import { Monitor, BarChart3, Brain, ShieldCheck, Code2, Smartphone, Cloud, Gamepad2, BookOpen } from 'lucide-react';

/* ── Pathway visual identity ──
   Replaces the old multi-colour emoji with brand-palette lucide icons.
   Keyed by a course's `track` so Home, Altera Scholar, Course Detail and the
   Dashboard all render the same icon and colour for the same pathway.

   To add a pathway: add an entry here — every page picks it up automatically.
     Icon  → lucide component        color → accent (icon, border, text)
     badge → .badge-* class          grad  → gradient for the icon tile */

const CYAN   = { color: '#00c8ff', badge: 'badge-cyan',   grad: 'linear-gradient(135deg, #00c8ff, #4488ff)' };
const PURPLE = { color: '#a855f7', badge: 'badge-purple', grad: 'linear-gradient(135deg, #a855f7, #e040fb)' };
const GREEN  = { color: '#00dc82', badge: 'badge-green',  grad: 'linear-gradient(135deg, #00dc82, #00c8ff)' };
const PINK   = { color: '#e040fb', badge: 'badge-pink',   grad: 'linear-gradient(135deg, #e040fb, #a855f7)' };

export const PATHWAYS = {
  'computer-science':     { Icon: Monitor,     ...CYAN },
  'data-science':         { Icon: BarChart3,   ...PURPLE },
  'ai-ml':                { Icon: Brain,       ...GREEN },
  'cybersecurity':        { Icon: ShieldCheck, ...PURPLE },
  'software-engineering': { Icon: Code2,       ...CYAN },
  'mobile-dev':           { Icon: Smartphone,  ...PINK },
  'cloud':                { Icon: Cloud,       ...CYAN },
  'game-dev':             { Icon: Gamepad2,    ...GREEN },
};

const FALLBACK = { Icon: BookOpen, ...CYAN };

export const getPathway = track => PATHWAYS[track] || FALLBACK;
